function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
export default function buildErrorScope(config, error, scope) {
    var _config_errors, _config_errors1;
    var _scope_project;
    const project = (_scope_project = scope === null || scope === void 0 ? void 0 : scope.project) !== null && _scope_project !== void 0 ? _scope_project : config.project;
    var _config_service, _config_page, _config_release;
    const tags = _object_spread({
        project,
        service: (_config_service = config.service) !== null && _config_service !== void 0 ? _config_service : '<unknown>',
        page: (_config_page = config.page) !== null && _config_page !== void 0 ? _config_page : '<unknown>',
        release: (_config_release = config.release) !== null && _config_release !== void 0 ? _config_release : '<unknown>',
        error_message: error.message,
        error_handled: 'true',
        error_issue_id: '<unknown>',
        error_issue_url: '<unknown>'
    }, config === null || config === void 0 ? void 0 : (_config_errors = config.errors) === null || _config_errors === void 0 ? void 0 : _config_errors.tags, scope === null || scope === void 0 ? void 0 : scope.tags);
    const extras = _object_spread({}, (_config_errors1 = config.errors) === null || _config_errors1 === void 0 ? void 0 : _config_errors1.extras, scope === null || scope === void 0 ? void 0 : scope.extras);
    return {
        project,
        tags,
        extras
    };
}

//# sourceMappingURL=buildErrorScope.js.map